import * as React from 'react';
import Ribbon from './Ribbon';
import RibbonPlugin from '../plugin/RibbonPlugin';
import RibbonViewState from '../store/schema/RibbonViewState';
import fontName from './buttons/fontName';
import fontSize from './buttons/fontSize';
import bold from './buttons/bold';
import italic from './buttons/italic';
import underline from './buttons/underline';
import backColor from './buttons/backColor';
import textColor from './buttons/textColor';
import setIsContextualFormatBarShown from '../actions/setIsContextualFormatBarShown';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { observer } from 'mobx-react';

export interface ContextualFormatBarProps {
    className?: string;
    ribbonPlugin: RibbonPlugin;
    viewState: RibbonViewState;
    isRtl: boolean;
}

const CONTEXTUAL_FORMAT_BAR_BUTTONS = [
    fontName,
    fontSize,
    bold,
    italic,
    underline,
    backColor,
    textColor,
];

@observer
export default class ContextualFormatBar extends React.Component<ContextualFormatBarProps, {}> {
    private formatBarDiv: HTMLElement;
    private suspendDismissOnce: boolean;

    render() {
        let { className, ribbonPlugin, viewState, isRtl } = this.props;
        let {
            isContextualFormatBarShown,
            contextualFormatBarLeft,
            contextualFormatBarTop,
        } = viewState;

        return (
            isContextualFormatBarShown && (
                <Callout
                    gapSpace={10}
                    isBeakVisible={false}
                    target={{ x: contextualFormatBarLeft, y: contextualFormatBarTop }}
                    directionalHint={DirectionalHint.topLeftEdge}
                    directionalHintForRTL={DirectionalHint.topRightEdge}
                    onDismiss={this.onDismiss}>
                    <div ref={ref => (this.formatBarDiv = ref)}>
                        <Ribbon
                            className={className}
                            ribbonPlugin={ribbonPlugin}
                            viewState={viewState}
                            skipInitialResize={true}
                            buttons={CONTEXTUAL_FORMAT_BAR_BUTTONS}
                            onDropDownDismissed={this.onDropDownDismissed}
                            focusToButtonBeforeDropDown={true}
                            isRtl={isRtl}
                        />
                    </div>
                </Callout>
            )
        );
    }

    private onDismiss = (evt: any) => {
        // Do not dismiss if clicking on buttons inside contextual format bar
        let target =
            evt instanceof FocusEvent && evt.relatedTarget instanceof Node
                ? evt.relatedTarget
                : null;
        let clickOnRibbon = target && this.formatBarDiv && this.formatBarDiv.contains(target);
        if (!clickOnRibbon && !this.suspendDismissOnce) {
            setIsContextualFormatBarShown(this.props.viewState, false /*isShown*/);
        }
        this.suspendDismissOnce = false;
    };

    private onDropDownDismissed = () => {
        this.suspendDismissOnce = true;
    };
}
